/**
 * `/catalog/*` routes v2 calls (API_ACCESS.md §3.1), held to the snapshot by `api/routes.test.ts`.
 */
import { gated } from "../../capabilities/access";
import { defineRoutes, route } from "../route";

export const CATALOG = defineRoutes("catalog", {
  referenceSale: route<undefined, unknown>("GET", "/catalog/reference/sale", gated({ modules: ["Sale", "Order", "Kiosk"] }), {
    notes:
      "the catalogue a sale is taken from (categories, menus, channels and the other sections); `catalog/fetch` (P1 slice 4). v1's session bootstrap sends it too until New Order's cutover",
  }),
});
